import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User edited a context field',
  name: 'context_field_edited',
  params: [
    {
      description: 'The source of the edit',
      name: 'source',
      required: true,
      type: 'enum',
      values: ['manual'],
    },
    {
      description: 'The name of the field',
      name: 'field_name',
      required: true,
      type: 'string',
    },
    {
      description: 'The new name of the field (only present when edit_type is renamed)',
      name: 'new_name',
      required: false,
      type: 'string',
    },
    {
      description: 'The type of edit performed',
      name: 'edit_type',
      required: true,
      type: 'enum',
      values: ['renamed', 'instructions_edited'],
    },
  ],
};

export default META;
